import React from "react";
import { NavLink } from "react-router-dom";

const MyNft = ({data}) => {
  
  return (
    <>
      <span className="link_wrapper" id="my"></span>
      <section className="default-settings">
        <div className="mynft__title-box">
          <div className="mynft__title-column column1"></div>
          <div className="mynft__title-column column2">
          <h1 className="mynft__title" style={{color:data.web_main_color}}>My {data.nft_name_plural ? data.nft_name_plural : "NFTs"}</h1>
          </div>
          <div className="mynft__title-column column3">
          </div>
        </div>
        <div className="mynft-cards">
          <h1 className="no-nft-text" style={{color: data.main_text_color}}>
              <NavLink to="/preview-home/buy">Buy</NavLink> or{" "}
              <NavLink to="/preview-home/mint">mint</NavLink> your first {data.nft_name}!
          </h1>
        </div>
      </section>
    </>
  );
};

export default MyNft;
